export default "__VITE_ASSET__11d6be6e__"